import {
  Box,
  Chip,
  CircularProgress,
  IconButton,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { getBillPDF, getpaymentInfo } from '../../services/payments';
import TopNav from '../common/TopNav';
import Container from '../Elements/Container';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { Link } from 'react-router-dom';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

const useStyles = makeStyles(theme => ({
  table: {
    marginTop: 10,
    padding: 5,
    '& .MuiTableCell-sizeSmall': {
      padding: theme.spacing(0.25),
    },
  },
  header: {
    background: theme.palette.primary.main,
  },
  headerCell: {
    color: theme.palette.common.white,
    fontWeight: 'bold',
  },
  noResultsBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
    textAlign: 'center',
  },
}));

export default function HistoryPayments() {
  const [loading, setLoading] = useState(false);
  const [purchases, setPurchases] = useState([]);

  useEffect(() => {
    getPayments();
  }, []);

  const getPayments = async () => {
    setLoading(true);
    try {
      const response = await getpaymentInfo();
      setPurchases(response?.data?.compras);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const labelsTableHeader = [
    'Plan',
    'Extras',
    'Duración',
    'Fecha de pago',
    'Fecha de vencimiento',
    'Costos fijos',
    'Monto USD',
    'Monto ARS',
    'Estado',
    'Factura'
  ];
  const classes = useStyles();

  const getPlanName = planId => {
    switch (planId) {
      case 2:
        return 'Experto';
      case 10:
        return 'Subfacturacion_Lite';
      case 6:
        return 'Profesional';
      case 5:
        return 'Básico';
      case 4:
        return 'Lite';
      default:
        return '-';
    }
  };

  const handleViewInvoice = async (item) => {
    if (!item?.id) return;
    try {
      const resp = await getBillPDF(item.id);

      const blob = new Blob([resp.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      window.open(url);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <TopNav titulo="Pagos" subtitulo="| Historial de compras" />
      <Container>
        {loading ? (
          <Box mt={6} display="flex" justifyContent="center">
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Link to="/pagos">
              <IconButton aria-label="seleccionar">
                <ChevronLeftIcon fontSize="inherit" />
              </IconButton>
            </Link>

            <Box p={4} pt={0}>
              {purchases?.length > 0 ? (
                <TableContainer component={Paper}>
                  <Table
                    size="small"
                    aria-label="Historial de alerta"
                    className={classes.table}
                  >
                    <TableHead>
                      <TableRow className={classes.header}>
                        {labelsTableHeader?.map(label => {
                          return (
                            <TableCell
                              key={label}
                              align="center"
                              className={classes.headerCell}
                            >
                              {label}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {purchases?.map(purchase => {
                        return (
                          <TableRow key={purchase.id} hover>
                            <TableCell align="center">
                              {getPlanName(purchase.plan)}
                            </TableCell>
                            <TableCell align="center">
                              {purchase.perks_chord &&
                                Object.keys(purchase.perks_chord).length > 0
                                ? Object.entries(purchase.perks_chord)
                                  .map(([key, value]) => `${key}: ${value}`)
                                  .join(', ')
                                : '-'}
                            </TableCell>
                            <TableCell align="center">
                              {purchase.duracion}
                            </TableCell>
                            <TableCell align="center">
                              {purchase.fecha_pago_styled}
                            </TableCell>
                            <TableCell align="center">
                              {purchase.plan_fecha_vencimiento_styled || '-'}
                            </TableCell>
                            <TableCell align="center">
                              {purchase.costos_fijos_chord &&
                                Object.keys(purchase.costos_fijos_chord).length > 0
                                ? Object.entries(purchase.costos_fijos_chord)
                                  .map(([key, value]) => `${key}: ${value} U$S`)
                                  .join(', ')
                                : '-'}
                            </TableCell>
                            <TableCell align="center">
                              U$S {purchase.total?.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '-'}
                            </TableCell>
                            <Tooltip title={`Cotización del día $${purchase.cotizacion} ARS`}>
                              <TableCell align="center">
                                $ {purchase.total_ars?.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) || '-'} ARS
                              </TableCell>
                            </Tooltip>
                            <TableCell align="center">
                              <Chip label={purchase.link_expirado ? 'Compra vencida' : purchase.estado} color={purchase.estado === 'Pagado' ? 'primary' : 'secondary'} />
                            </TableCell>
                            <TableCell align="center">
                              {true ?
                                <Tooltip title="Ver factura">
                                  <span>
                                    <IconButton
                                      aria-label="Ver factura"
                                      onClick={() => handleViewInvoice(purchase)}
                                      size="small"
                                    >
                                      <PictureAsPdfIcon />
                                    </IconButton>
                                  </span>
                                </Tooltip> :
                                '-'
                              }
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Box className={classes.noResultsBox}>No hay resultados.</Box>
              )}
            </Box>
          </>
        )}
      </Container>
    </>
  );
}
